































import { Vue, Component, Prop } from 'vue-property-decorator';

import { LoadingService } from '@/services/loadingService';
import { Snotify } from '@/snotify/Snotify';

import { fetchMS } from './fetchMS';

import PopUpGenerateReports from './PopUpGenerateReports.vue';

import {
  ParamApi,
  FiltersApi,
  DateType,
} from '@/pantallas/Conecta/BajasCobranza/models/BajasCobranza.models';
import ModalCargueArchivo from './ModalCargueArchivo.vue';

@Component({ components: { PopUpGenerateReports, ModalCargueArchivo } })
export default class BajasCobranzaActions extends Vue {
  @Prop({ required: true, default: {} }) paramApi!: ParamApi;
  @Prop({ required: true, default: [] }) dataList!: any[];

  readonly loadingService: LoadingService = new LoadingService();
  readonly $snotify: Snotify = null;

  msgReport: string = '';
  dialogPopUp: boolean = false;
  dialogModal: boolean = false;
  filterApi: FiltersApi = {};

  handleCloseReport() {
    this.dialogPopUp = false;
    this.msgReport = '';
    this.dialogModal = false;
  }
  mounted() {
    this.getFilters();
  }

  openUpload() {
    this.dialogModal = true;
  }
  async getCSV() {
    const { length: count } = this.dataList;
    if (!count) {
      this.$snotify.error('No hay datos disponibles para generar el reporte', {
        timeout: 3000,
      });
      return;
    }
    try {
      const userId = JSON.parse(localStorage.getItem('user')).id;
      const user = localStorage.getItem('clienteDefecto');
      this.loadingService.showLoading(null, 'getCSV');
      const body = {
        start_date: this.paramApi.start_date,
        end_date: this.paramApi.end_date,
        rut_cliente:
          (this.paramApi.cliente && this.paramApi.cliente.rut_cliente) || '',
        estado_conecta: this.paramApi.estado_conecta
          ? this.paramApi.estado_conecta.id_estado_conecta
          : '',
        id_date: Number(this.paramApi.typeDate.id_date),
        name_date: this.paramApi.typeDate.name_date,
        user_id: userId,
        user,
        baja_temporal: this.paramApi.baja_temporal
          ? this.paramApi.baja_temporal.id_baja_temporal
          : '',
        baja_definitiva: this.paramApi.baja_definitiva
          ? this.paramApi.baja_definitiva.id_baja_definitiva
          : '',
        razon_estado: this.paramApi.razon_estado
          ? this.paramApi.razon_estado.razon
          : '',
        nombre_baja: this.paramApi.bajaCobranza
          ? this.paramApi.bajaCobranza
          : '',
        count,
        dict_params: { ...this.paramApi },
      };
      const result = await fetchMS({
        endpoint: 'export_excel',
        body,
      });
      const { CODIGO_RESPUESTA, MENSAJE_RESPUESTA } = result.data;
      const cod: number = Number(CODIGO_RESPUESTA);

      if (cod !== 1) {
        throw new Error(MENSAJE_RESPUESTA);
      }
      this.msgReport = MENSAJE_RESPUESTA;
      this.dialogPopUp = true;
    } catch (error) {
      if (error instanceof Error && error.message !== 'Network Error') {
        this.$snotify.error(error.message, { timeout: 3000 });
        return;
      }
      this.$snotify.error(
        'Ha ocurrido un error inesperado, por favor intente más tarde',
        { timeout: 3000 }
      );
    } finally {
      this.loadingService.hideLoading('getCSV');
    }
  }

  async getFilters() {
    try {
      this.loadingService.showLoading(null, 'get');
      const result = await fetchMS({ endpoint: 'get_filters' });
      const { MENSAJE_RESPUESTA, CODIGO_RESPUESTA, FILTERS } = result.data;
      if (Number(CODIGO_RESPUESTA) !== 1) {
        this.$snotify.error(MENSAJE_RESPUESTA, { timeout: 3000 });
        return;
      }
      this.filterApi = { ...FILTERS };
    } catch (error) {
      this.$snotify.error(
        'Ha ocurrido un error inesperado, por favor intente más tarde',
        { timeout: 3000 }
      );
    } finally {
      this.loadingService.hideLoading('get');
    }
  }
}
